import { createFileRoute } from "@tanstack/react-router";
import { useAuth0Login } from "../../hooks/useAuth0Login";
import { PersonalisationModal } from "~/components/dashboard";
import { dashboardSearchSchema } from "~/utils/validation-schemas";
import { Spinner } from "~/components/ui/spinner";
import ApplicationsView from "~/components/dashboard/applications-view";

export const Route = createFileRoute("/_protected/dashboard")({
  component: DashboardPage,
  validateSearch: dashboardSearchSchema,
});

function DashboardPage() {
  const { isAuthenticated, isLoading } = useAuth0Login();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <Spinner className="size-8 text-brand-green-primary" />
      </div>
    );
  }

  return (
    <div className="bg-gray-50">
      {isAuthenticated && <PersonalisationModal />}
      <div className="max-w-7xl mx-auto p-6">
        <ApplicationsView />
      </div>
    </div>
  );
}

export default DashboardPage;
